










































import {Component, Mixins, Prop} from 'vue-property-decorator'
import Translation from '@/mixins/Translation'
import EmptyMessage from '@/components/EmptyMessage.vue'

@Component({
  components: {EmptyMessage}
})
export default class InvoiceDocument extends Mixins(Translation) {
  @Prop({default: 'terms', type: String}) translation: string
  @Prop({default: '', type: String}) data: string

  get documentData(): string {
    return this.data || ''
  }
}
